import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {Action} from '@ngrx/store';
import {LoaderService} from '@app/services/loader.service';
import {InfluencerSsoService} from '@app/services/influencer-sso.service';
import {
  InfluencerSsoCreate,
  InfluencerSsoCreateError,
  InfluencerSsoCreateSuccess,
  InfluencerSsoDelete,
  InfluencerSsoDeleteError,
  InfluencerSsoDeleteSuccess,
  InfluencerSsoList,
  InfluencerSsoListError,
  InfluencerSsoListSuccess,
  InfluencerSsoUpdate,
  InfluencerSsoUpdateError,
  InfluencerSsoUpdateSuccess
} from './influencer-sso.actions';

@Injectable()
export class InfluencerSsoEffects {
  private actions$ = inject(Actions);
  private service = inject(InfluencerSsoService);
  private loader = inject(LoaderService);


  list$ = createEffect(() => this.actions$.pipe(
    ofType(InfluencerSsoList),
    switchMap((action) => {
      this.loader.show();
      return this.service.getAll(action.params).pipe(
        map((resp: any) => {
          this.loader.hide(!resp.success);
          return resp.success
            ? InfluencerSsoListSuccess({paginatedInfluencerSso: resp.data})
            : InfluencerSsoListError({error: this.loader.getErrorMessage(resp)});
        }),
        catchError((error) => {
          this.loader.hide(true);
          return of(InfluencerSsoListError({error: this.loader.getErrorMessage(error)}));
        })
      );
    })
  ));

  create$ = createEffect(() => this.actions$.pipe(
    ofType(InfluencerSsoCreate),
    switchMap((action) => this.mutate(
      this.service.create(action.setting),
      InfluencerSsoCreateSuccess,
      InfluencerSsoCreateError
    ))
  ));

  update$ = createEffect(() => this.actions$.pipe(
    ofType(InfluencerSsoUpdate),
    switchMap((action) => this.mutate(
      this.service.update(action.id, action.setting),
      InfluencerSsoUpdateSuccess,
      InfluencerSsoUpdateError
    ))
  ));

  delete$ = createEffect(() => this.actions$.pipe(
    ofType(InfluencerSsoDelete),
    switchMap((action) => this.mutate(
      this.service.delete(action.id),
      InfluencerSsoDeleteSuccess,
      InfluencerSsoDeleteError
    ))
  ));

  private mutate(
    request: Observable<any>,
    successAction: () => Action,
    errorAction: (params: {error: string}) => Action
  ): Observable<Action> {
    this.loader.show();
    return request.pipe(
      map((resp: any) => {
        this.loader.hide(!resp.success);
        return resp.success
          ? successAction()
          : errorAction({error: this.loader.getErrorMessage(resp)});
      }),
      catchError((error) => {
        this.loader.hide(true);
        return of(errorAction({error: this.loader.getErrorMessage(error)}));
      })
    );
  }
}
